"use client";

import { c as _c } from "react/compiler-runtime";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CircularProgress from "@mui/material/CircularProgress";
import useEmblaCarousel from "embla-carousel-react";
import React, { useCallback, useEffect, useState } from "react";
import { sortEventsByStartDate } from "@/app/(main)/(club)/mes-clubs/[id]/utils/sort-events-by-date";
import { PublicExternalEventCard } from "@/app/(main)/(public)/club/[slug]/components/public-external-event-card";
import { usePublicExternalEvents } from "@/queries/use-public-external-events";
import { Club } from "@/TS/Interfaces/global_interfaces";
interface PublicExternalEventsProps {
  club: Club;
}
export const PublicExternalEvents: React.FC<PublicExternalEventsProps> = t0 => {
  const $ = _c(32);
  const {
    club
  } = t0;
  const {
    data: eventsData,
    isLoading,
    isError,
    error
  } = usePublicExternalEvents(club.slug);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      containScroll: "trimSnaps",
      slidesToScroll: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t2;
  if ($[1] !== emblaApi) {
    t2 = () => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    };
    $[1] = emblaApi;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const scrollPrev = t2;
  let t3;
  if ($[3] !== emblaApi) {
    t3 = () => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    };
    $[3] = emblaApi;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const scrollNext = t3;
  let t4;
  if ($[5] !== emblaApi) {
    t4 = index => {
      if (emblaApi) {
        emblaApi.scrollTo(index);
      }
    };
    $[5] = emblaApi;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const scrollTo = t4;
  let t5;
  if ($[7] !== emblaApi) {
    t5 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
    };
    $[7] = emblaApi;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onSelect = t5;
  let t6;
  let t7;
  if ($[9] !== emblaApi || $[10] !== onSelect) {
    t6 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      emblaApi.on("reInit", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
        emblaApi.off("reInit", onSelect);
      };
    };
    t7 = [emblaApi, onSelect];
    $[9] = emblaApi;
    $[10] = onSelect;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[13] !== canScrollNext || $[14] !== canScrollPrev || $[15] !== emblaRef || $[16] !== error || $[17] !== eventsData || $[18] !== isError || $[19] !== isLoading || $[20] !== scrollNext || $[21] !== scrollPrev || $[22] !== scrollTo || $[23] !== selectedIndex) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const events = sortEventsByStartDate(eventsData?.["hydra:member"] || []);
      const hasEvents = events.length > 0;
      if (!isLoading && !isError && !hasEvents) {
        t9 = null;
        break bb0;
      }
      let t10;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <div className="flex items-center justify-center mb-4 relative"><h3 className="font-bold text-3xl text-white text-center">Événements extérieurs à venir</h3></div>;
        $[26] = t10;
      } else {
        t10 = $[26];
      }
      let t11;
      if ($[27] !== isLoading) {
        t11 = isLoading && <div className="flex justify-center py-8"><CircularProgress sx={{
            color: "white"
          }} /></div>;
        $[27] = isLoading;
        $[28] = t11;
      } else {
        t11 = $[28];
      }
      let t12;
      if ($[29] !== error || $[30] !== isError) {
        t12 = isError && <p className="text-red-300 text-center">Erreur lors du chargement des événements :{" "}{error instanceof Error ? error.message : "Erreur inconnue"}</p>;
        $[29] = error;
        $[30] = isError;
        $[31] = t12;
      } else {
        t12 = $[31];
      }
      t8 = <div className="rounded bg-dark-blue p-6 relative">{t10}{t11}{t12}{!isLoading && !isError && hasEvents && <div className="relative -mx-6"><div className="overflow-hidden px-6" ref={emblaRef}><div className="flex touch-pan-y -mx-2">{events.map(_temp)}</div></div>{events.length > 1 && <><button onClick={scrollPrev} disabled={!canScrollPrev} className={`flex absolute left-2 top-[45%] -translate-y-1/2 bg-white rounded-full w-10 h-10 items-center justify-center shadow-lg transition-all z-10 ${canScrollPrev ? "opacity-100 hover:bg-gray-100" : "opacity-0 pointer-events-none"}`} aria-label={"\xC9v\xE9nement pr\xE9c\xE9dent"}><ChevronLeftIcon className="text-dark-blue" /></button><button onClick={scrollNext} disabled={!canScrollNext} className={`flex absolute right-2 top-[45%] -translate-y-1/2 bg-white rounded-full w-10 h-10 items-center justify-center shadow-lg transition-all z-10 ${canScrollNext ? "opacity-100 hover:bg-gray-100" : "opacity-0 pointer-events-none"}`} aria-label={"\xC9v\xE9nement suivant"}><ChevronRightIcon className="text-dark-blue" /></button></>}{events.length > 1 && <div className="flex justify-center gap-2 mt-6">{events.map((_, index_0) => <button key={index_0} onClick={() => scrollTo(index_0)} className={`h-2 rounded-full transition-all ${index_0 === selectedIndex ? "bg-white w-8" : "bg-white/50 hover:bg-white/75 w-2"}`} aria-label={`Aller à l'événement ${index_0 + 1}`} />)}</div>}</div>}</div>;
    }
    $[13] = canScrollNext;
    $[14] = canScrollPrev;
    $[15] = emblaRef;
    $[16] = error;
    $[17] = eventsData;
    $[18] = isError;
    $[19] = isLoading;
    $[20] = scrollNext;
    $[21] = scrollPrev;
    $[22] = scrollTo;
    $[23] = selectedIndex;
    $[24] = t8;
    $[25] = t9;
  } else {
    t8 = $[24];
    t9 = $[25];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  return t8;
};
function _temp(event) {
  return <div key={event.id} className="flex-[0_0_100%] min-w-0 px-2"><PublicExternalEventCard event={event} /></div>;
}